export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9410.4c2c8fa6.jpg";